import { useSelector } from "react-redux";
import { useNodePreview, useStartNode, useInputPreview } from "../../../custom-hooks/useNodePreview";
import BtnGroupStyle from "../css/BtnGroup.module.css";
import { logEvent } from "@amplitude/analytics-browser";
import { usePreviewAppStore } from "@custom-hooks/HomeUsePluginRoot/usePreviewAppStore";
const groupReg = /^group/;

const hideTypes = ["Agent"];

export const PreviewButton = ({
  id,
  getNodes,
  displayType,
  isStaticApp,
  handlePreviewDeleteNode,
  clickToPreviewNode,
  clickAddInputField,
}) => {
  const { isStartNode, isStartNodeAdded } = useStartNode(id);
  const disableAddPreview = useSelector(state => state.fot.disableAddPreview);

  const wrapperClassName = `${BtnGroupStyle["preview-btn-wrapper"]} ${
    BtnGroupStyle[
      groupReg.test(id) ? "group-wrapper" : displayType === "inputTextarea" ? "stickie-wrapper" : "node-wrapper"
    ]
  }`;

  if (hideTypes.includes(displayType)) return null;

  if (disableAddPreview) return null;

  if (isStartNode && !isStartNodeAdded && !isStaticApp)
    return (
      <div className={BtnGroupStyle["preview-btn-wrapper"]}>
        <PreviewInputButton id={id} getNodes={getNodes} clickAddInputField={clickAddInputField} />
      </div>
    );

  if (!isStartNode)
    return (
      <div>
        <PreviewNodeButton
          id={id}
          getNodes={getNodes}
          wrapperClassName={wrapperClassName}
          handlePreviewDeleteNode={handlePreviewDeleteNode}
          clickToPreviewNode={clickToPreviewNode}
        />
      </div>
    );
};

const handleTogglePreviewNodeButton = (nodeClassName, btnText) => {
  const eventProperties = {
    node_class_name: nodeClassName,
    button_text: btnText,
  };
  logEvent("toggle_publish_preview_node_button", eventProperties);
};

export const PreviewNodeButton = props => {
  const { nodeClassName, nodeAddIconClassName, hasAdded, btnText, handlePreview } = useNodePreview(props);
  const { enableRemovePreview } = usePreviewAppStore();
  return (
    <>
      {enableRemovePreview(hasAdded) && (
        <div className={props.wrapperClassName}>
          <div
            className={BtnGroupStyle[nodeClassName]}
            shape="round"
            size="large"
            onClick={() => {
              handlePreview();
              handleTogglePreviewNodeButton(nodeClassName, btnText);
            }}
          >
            {!hasAdded && (
              <svg
                className={BtnGroupStyle[nodeAddIconClassName]}
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
              >
                <path
                  d="M683.968 534.944H544v139.968a32 32 0 0 1-64 0v-139.968h-139.968a32 32 0 0 1 0-64H480v-139.968a32 32 0 0 1 64 0v139.968h139.968a32 32 0 0 1 0 64M512 128C300.256 128 128 300.288 128 512c0 211.744 172.256 384 384 384s384-172.256 384-384c0-211.712-172.256-384-384-384"
                  fill="#B6DEFF"
                ></path>
              </svg>
            )}
            {hasAdded && (
              <svg
                className={BtnGroupStyle[nodeAddIconClassName]}
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="20" height="20" rx="10" fill="#020C26" fillOpacity="0.1" />
                <path d="M5 10H15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
            <span>{btnText}</span>
          </div>
        </div>
      )}
    </>
  );
};

export const PreviewInputButton = props => {
  const { nodeClassName, btnText, handlePreview } = useInputPreview(props);
  return (
    <span className={BtnGroupStyle[nodeClassName]} shape="round" size="large" onClick={handlePreview}>
      {btnText}
    </span>
  );
};
